import Breadcrumb from "../components/presentation/Breadcrumb";

const Contact = () => {
  return <div className="container">
    <Breadcrumb page="Contact" />
    <h1>Contact AZGS</h1>
    <dl>
      <dt>Arizona Geological Survey</dt>
      <dd>1955 East Sixth Street <br />
        PO Box 210184</dd>
      <dt>Phone</dt>
      <dd>520-621-2470</dd>
      <dt>Email</dt>
      <dd><a href="mailto:azgs-info@arizona.edu">azgs-info@arizona.edu</a></dd>
      <dt>GitHub Issues</dt>
      <dd><a href="https://github.com/azgs/azlibrary_react/issues" target="_blank" rel="noopener noreferrer">https://github.com/azgs/azlibrary_react/issues</a></dd>
    </dl>
  </div>;
};

export default Contact;